import * as React from "react";
import type { SVGProps } from "react";
const SvgStopFill = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill={props.color}
    viewBox="0 0 256 256"
    {...props}
  >
    <path d="M216 56v144a16 16 0 0 1-16 16H56a16 16 0 0 1-16-16V56a16 16 0 0 1 16-16h144a16 16 0 0 1 16 16" />
  </svg>
);
export default SvgStopFill;
